import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import pic08 from '../assets/images/pic08.jpg'
// import pic09 from '../assets/images/pic09.jpg'
import pic10 from '../assets/images/pic10.jpg'
import couch3 from '../assets/images/couch3.jpg'
import bike3 from '../assets/images/bike3.jpg'

const Snippets = props => (
  <div>
    <Helmet>
      <title>Jody Smith - Snippets</title>
      <meta name="description" content="About Me Page" />
    </Helmet>

    <div id="main">
      <section id="banner" className="style2">
        <div className="inner">
          <header className="major">
            <h1>Snippets</h1>
          </header>
          <div className="content">
            <p>
              A Small collection of javascript code snippets I find myself using
              frequently. These are mostly here as a reminder to myself, but
              feel free to use them if they are of any use to you.
            </p>
          </div>
        </div>
      </section>
      <section id="one">
        <div className="inner">
          <p>
            <a href="#unixTime">Convert Unix Time to human readable date</a>
            <br />
            <a href="#lambdaPost">
              Netlify Lambda POST boiler plate with error handler and data check
            </a>
            <br />
            <a href="#reactRedux">
              React Componenet Class with Redux Store and defualt Reducer
            </a>
            <br />
          </p>

          <p>
            <figure id="unixTime">
              <figcaption>Convert Unix Time to human readable date</figcaption>
              <pre>
                <code>
                  {`const dateConvert =(UNIX_timestamp) => {
    let a = new Date(UNIX_timestamp * 1000);
    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    let year = a.getFullYear();
    let month = months[a.getMonth()];
    let date = a.getDate();
    let hour = a.getHours();
    let min = a.getMinutes();
    let sec = a.getSeconds();
    let time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    return time;
}

module.exports = {
    dateConvert : dateConvert
}
`}
                </code>
              </pre>
            </figure>

            <figure id="lambdaPost">
              <figcaption>
                Netlify Lambda POST boiler plate with error handler and data
                check
              </figcaption>
              <pre>
                <code>
                  {`import dotenv from 'dotenv'
dotenv.config()

const statusCode = 200
const headers = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Headers': 'Content-Type',
}

exports.handler = function(event, context, callback) {
  // basic error handler to respond back to request source if there's an issue
  const handleError = (message) => {
    callback(null, {
      statusCode,
      headers,
      body: JSON.stringify({ type: message }),
    })
  }

  // We only want to respond if this is a POST request.
  if (event.httpMethod !== 'POST' || !event.body) {
    handleError('Please use POST')
    return
  }

  // Parse Post body back into JSON object
  let data = JSON.parse(event.body)

  // Verify expected data is present
  if (
    !data.id ||
    !data.name 
  ) {
    handleError('missing data in request')
    return
  }

  // echo request to verify everythign is set up, can be removed once logic is entered.
  callback(null, {
    statusCode,
    headers,
    body: event.body,
  })
}
`}
                </code>
              </pre>
            </figure>

            <figure id="reactRedux">
              <figcaption>
                React Componenet Class with Redux Store and defualt Reducer
              </figcaption>
              <pre>
                <code>
                  {`import React, { Component } from 'react'
import { connect } from 'react-redux'

class ClassName extends Component {
    
    // this assumes a reducer with the UPDATE_STATE case.
    updateState = (item, value) => {
        this.props.dispatch({ type: 'UPDATE_STATE', item: item, value: value })
      }
  
    render() {
    return (
    <div>
        {console.log(this.props.data)}
        Hello World
    </div>)
  }
}
const mapStateToProps = state => {
  return {
    data: state.data,
  }
}

export default connect(mapStateToProps)(ClassName)`}
                </code>
              </pre>
            </figure>
          </p>
        </div>
      </section>
    </div>
  </div>
)

export default Snippets

{
  ;`import React, { Component } from 'react'
import { connect } from 'react-redux'

class ClassName extends Component {
    
    // this assumes a reducer with the UPDATE_STATE case.
    updateState = (item, value) => {
        this.props.dispatch({ type: 'UPDATE_STATE', item: item, value: value })
      }
  
    render() {
    return (
    <div>
        {console.log(this.props.data)}
        Hello World
    </div>)
  }
}
const mapStateToProps = state => {
  return {
    data: state.data,
  }
}

export default connect(mapStateToProps)(ClassName)`
}



// WEBPACK FOOTER //
// ./src/pages/snippets.js